export const ValidatorsIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.3333 28V25.3333C21.3333 23.9188 20.7714 22.5623 19.7712 21.5621C18.771 20.5619 17.4144 20 16 20H7.99996C6.58547 20 5.22892 20.5619 4.22872 21.5621C3.22853 22.5623 2.66663 23.9188 2.66663 25.3333V28"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3334 4.17065C22.477 4.46715 23.4899 5.13501 24.2129 6.0694C24.936 7.0038 25.3283 8.15184 25.3283 9.33332C25.3283 10.5148 24.936 11.6628 24.2129 12.5972C23.4899 13.5316 22.477 14.1995 21.3334 14.496"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3334 28V25.3333C29.3325 24.1516 28.9392 23.0037 28.2152 22.0698C27.4912 21.1358 26.4775 20.4688 25.3334 20.1733"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14.6667C14.9455 14.6667 17.3333 12.2789 17.3333 9.33333C17.3333 6.38781 14.9455 4 12 4C9.05444 4 6.66663 6.38781 6.66663 9.33333C6.66663 12.2789 9.05444 14.6667 12 14.6667Z"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
